<template>
  <div class="global-feature-filters">
    <div class="global-filter form-group form-check">
      <div
        class="custom-control custom-checkbox"
        v-for="(filter, index) in availableFilters"
        :key="index"
      >
        <input
          type="checkbox"
          class="custom-control-input"
          :id="filter.name"
          @change="onChange($event, filter)"
          :checked="filter.value"
          :value="filter.value"
        />
        <label class="custom-control-label" :for="filter.name">
          {{ filter.name }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/eventbus";
import NonReleasedCombinationsModal from "@/components/modals/NonReleasedCombinationsModal";

export default {
  name: "GlobalFeatureFilters",
  computed: {
    ...mapGetters("brain/global", ["availableFilters"]),
  },
  modals: {
    NonReleasedCombinationsModal,
  },
  methods: {
    onChange(event, filter) {
      const isChecked = event.target.checked;

      if (filter.field === "whitelistingEnabled" && !isChecked) {
        this.$modalRouter.push({
          name: "NonReleasedCombinationsModal",
          props: { show: true },
          model: "show",
        });
      }

      this.$store.commit("brain/global/updateFilter", { filter, isChecked });
      EventBus.$emit("brain/modules/handleFilterChange", {});
      EventBus.$emit("brain/drivers/handleFilterChange", {});
    },
  },
};
</script>
